"use client";

import React, { useEffect, useState } from "react";

const token = 'BQA-Fq9Z1SX1lEK5i5Q1kDht9duOG38AVmePCRFriaKyGEMstCIHaFlLcGBnNy8RP87cytHsR-FVvVbIOsDlzcQOehOmY7tq3w74BgGq0wrnt4jrcOvYH7r-AKpMSpoOwbJbp5sa7-PD7fY_bxmYuc-oSueMiz9GXWVhfWtSdO5OT9U_FapkZTf44V4FiZ4l7V2kq_NOfopiFjNzgpNrHs4i1vZ45SwidPeeb5d5uC92UrNbyuH8PgLgddrpYfoGUfqA7nMJVDI06K4Ksfk1Ww49W05O7yi8tvSHIC0WM5YVZz4yDhVTJZMJ0ORW';

async function fetchWebApi(endpoint, method, body) {
    const res = await fetch(`https://api.spotify.com/${endpoint}`, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
        method,
        body: JSON.stringify(body),
    });
    return await res.json();
}

async function getTopTrack() {
    const data = await fetchWebApi('v1/me/top/tracks?time_range=long_term&limit=1', 'GET');
    return data.items[0];
}

export default function SpotifyNowPlaying() {
    const [track, setTrack] = useState(null);

    useEffect(() => {
        const lastFetch = localStorage.getItem('spotify-last-fetch');
        const today = new Date().toISOString().split('T')[0];

        if (lastFetch === today) return; // Already fetched today

        const fetchTrack = async () => {
            try {
                const topTrack = await getTopTrack();
                setTrack(topTrack);
                localStorage.setItem('spotify-last-fetch', today);
                localStorage.setItem('spotify-track', JSON.stringify(topTrack));
            } catch (err) {
                console.error("Failed to fetch Spotify top track:", err);
            }
        };

        fetchTrack();
    }, []);

    useEffect(() => {
        const cachedTrack = localStorage.getItem('spotify-track');
        if (cachedTrack) {
            setTrack(JSON.parse(cachedTrack));
        }
    }, []);

    if (!track) return null;

    return (
        <div>
            <div className="border border-stone-800/90 p-3 rounded-lg flex flex-row-reverse justify-between" style={{ opacity: 1, transform: 'none' }}>
                <div className="w-20 h-20">
                    <img
                        src={track.album.images[0].url}
                        alt="cover-image"
                        className="object-fit rounded-lg shadow-lg grayscale hover:grayscale-0 duration-300 ease-in"
                    />
                </div>
                <div className="flex flex-col gap-2 h-20 items-start justify-between">
                    <p className="mb-0 leading-none text-sm text-zinc-500">Most played</p>
                    <div className="mb-1 font-semibold eduheder leading-none">
                        <a
                            href={track.external_urls.spotify}
                            target="_blank"
                            rel="noreferrer"
                            className="no-underline"
                        >
                            {track.name} || {track.artists.map((artist) => artist.name).join(", ")}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}